import { useContext } from 'react';
import {
  Box,
  alpha,
  lighten,
  IconButton,
  Tooltip,
  styled,
  useTheme,
  Typography
} from '@mui/material';
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
import { SidebarContext } from 'src/contexts/SidebarContext';

import HeaderUserbox from './Userbox';
import { FormattedMessage } from 'react-intl';

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        right: 0;
        z-index: 7;
        background-color: ${alpha(theme.header.background, 0.95)};
        backdrop-filter: blur(3px);
        position: fixed;
        justify-content: space-between;
        width: 100%;
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            left: ${theme.sidebar.width};
            width: auto;
        }
`
);

function Header() {
  const { toggleSidebar, title } = useContext(SidebarContext);
  const theme = useTheme();

  return (
    <HeaderWrapper
      display="flex"
      alignItems="center"
      sx={{
        boxShadow:
          theme.palette.mode === "dark"
            ? `0 1px 0 ${alpha(
                lighten(theme.colors.primary.main, 0.7),
                0.15
              )}, 0px 2px 8px -3px rgba(0, 0, 0, 0.2), 0px 5px 22px -4px rgba(0, 0, 0, .1)`
            : `0px 2px 8px -3px ${alpha(
                theme.colors.alpha.black[100],
                0.2
              )}, 0px 5px 22px -4px ${alpha(
                theme.colors.alpha.black[100],
                0.1
              )}`,
      }}
    >
      <Box
        component="span"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}>
        <Tooltip
          arrow
          title={<FormattedMessage id='toggleMenu' />}
          sx={{
            display: { lg: "none", xs: "inline-block" },
          }}
        >
          <IconButton color="primary" onClick={toggleSidebar}>
              <MenuTwoToneIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Typography variant="h3" component="h3" gutterBottom>
          <FormattedMessage id={title} />
        </Typography>
      </Box>
      <Box
        component="span"
        sx={{
          display: "flex",
          alignItems: "center",
          ml: 2,
          justifyContent: "flex-end",
        }}
      >
        <HeaderUserbox />
      </Box>
    </HeaderWrapper>
  );
}

export default Header;
